// Aurora Innovation, Inc. Proprietary and Confidential. Copyright 2026.
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { alertClasses } from '@mui/material/Alert';
import { buttonClasses } from '@mui/material/Button';
import { iconButtonClasses } from '@mui/material/IconButton';
import { rem } from '../../tokens/conversions';
import { borderRadius, spacing } from '../../tokens/spacing';
import { alertColors } from './alertColors';
export var Alert = function(mode) {
    var c = alertColors(mode);
    var _obj, _obj1, _obj2, _obj3, _obj4, _obj5, _obj6, _obj7, _obj8, _obj9, _obj10, _obj11;
    var override = {
        MuiAlert: {
            styleOverrides: {
                root: (_obj7 = {
                    padding: "".concat(rem(spacing[1]), " ").concat(rem(spacing[3])),
                    borderRadius: rem(borderRadius.default),
                    alignItems: 'center',
                    gap: rem(spacing[2]),
                    minHeight: rem(48),
                    overflow: 'clip',
                    fontSize: rem(14),
                    lineHeight: rem(18)
                }, // Figma's Alert action slot only specs the outlined/text (transparent-background)
                // Button variants — they should inherit the alert's action color. Contained,
                // destructive, filter, and invertedContained bring their own opaque background and
                // a text color from Button.tsx designed to pair with it; forcing `inherit` on those
                // clobbers that pairing and can render invisible text (e.g. dark-on-dark).
                _define_property(_obj7, ".".concat(buttonClasses.text, ", .").concat(buttonClasses.outlined), {
                    color: 'inherit'
                }), // IconButton has no MUI-generated per-variant utility class to scope against (unlike
                // Button's `.MuiButton-contained`), so this stays unconditional. Figma's Alert spec
                // only ever shows the transparent dismiss/close IconButton here, never a contained one.
                _define_property(_obj7, ".".concat(iconButtonClasses.root), {
                    color: 'inherit'
                }), _define_property(_obj7, ".".concat(alertClasses.icon), {
                    alignItems: 'center',
                    padding: 0,
                    marginRight: 0,
                    fontSize: rem(20)
                }), _define_property(_obj7, ".".concat(alertClasses.message), {
                    padding: 0
                }), _define_property(_obj7, ".".concat(alertClasses.action), {
                    padding: 0,
                    marginRight: 0,
                    alignItems: 'center',
                    color: c.action
                }), _define_property(_obj7, "&.".concat(alertClasses.standard), (_obj = {}, _define_property(_obj, "&.".concat(alertClasses.standardError), _define_property({
                    backgroundColor: c.error.background,
                    color: c.error.text
                }, ".".concat(alertClasses.icon), {
                    color: c.error.icon
                })), _define_property(_obj, "&.".concat(alertClasses.standardInfo), _define_property({
                    backgroundColor: c.info.background,
                    color: c.info.text
                }, ".".concat(alertClasses.icon), {
                    color: c.info.icon
                })), _define_property(_obj, "&.".concat(alertClasses.standardSuccess), _define_property({
                    backgroundColor: c.success.background,
                    color: c.success.text
                }, ".".concat(alertClasses.icon), {
                    color: c.success.icon
                })), _define_property(_obj, "&.".concat(alertClasses.standardWarning), _define_property({
                    backgroundColor: c.warning.background,
                    color: c.warning.text
                }, ".".concat(alertClasses.icon), {
                    color: c.warning.icon
                })), _obj)), _define_property(_obj7, "&.".concat(alertClasses.outlined), (_obj1 = {
                    borderWidth: rem(1)
                }, _define_property(_obj1, "&.".concat(alertClasses.outlinedError), _define_property({
                    backgroundColor: c.error.background,
                    color: c.error.text,
                    borderColor: c.error.border
                }, ".".concat(alertClasses.icon), {
                    color: c.error.icon
                })), _define_property(_obj1, "&.".concat(alertClasses.outlinedInfo), _define_property({
                    backgroundColor: c.info.background,
                    color: c.info.text,
                    borderColor: c.info.border
                }, ".".concat(alertClasses.icon), {
                    color: c.info.icon
                })), _define_property(_obj1, "&.".concat(alertClasses.outlinedSuccess), _define_property({
                    backgroundColor: c.success.background,
                    color: c.success.text,
                    borderColor: c.success.border
                }, ".".concat(alertClasses.icon), {
                    color: c.success.icon
                })), _define_property(_obj1, "&.".concat(alertClasses.outlinedWarning), _define_property({
                    backgroundColor: c.warning.background,
                    color: c.warning.text,
                    borderColor: c.warning.border
                }, ".".concat(alertClasses.icon), {
                    color: c.warning.icon
                })), _obj1)), _define_property(_obj7, "&.".concat(alertClasses.filled), (_obj6 = {}, _define_property(_obj6, "&.".concat(alertClasses.filledError), (_obj2 = {
                    backgroundColor: c.bold.error.background,
                    color: c.bold.error.text
                }, _define_property(_obj2, ".".concat(alertClasses.icon), {
                    color: c.bold.error.icon
                }), _define_property(_obj2, ".".concat(alertClasses.action), {
                    color: c.bold.error.action
                }), _obj2)), _define_property(_obj6, "&.".concat(alertClasses.filledInfo), (_obj3 = {
                    backgroundColor: c.bold.info.background,
                    color: c.bold.info.text
                }, _define_property(_obj3, ".".concat(alertClasses.icon), {
                    color: c.bold.info.icon
                }), _define_property(_obj3, ".".concat(alertClasses.action), {
                    color: c.bold.info.action
                }), _obj3)), _define_property(_obj6, "&.".concat(alertClasses.filledSuccess), (_obj4 = {
                    backgroundColor: c.bold.success.background,
                    color: c.bold.success.text
                }, _define_property(_obj4, ".".concat(alertClasses.icon), {
                    color: c.bold.success.icon
                }), _define_property(_obj4, ".".concat(alertClasses.action), {
                    color: c.bold.success.action
                }), _obj4)), _define_property(_obj6, "&.".concat(alertClasses.filledWarning), (_obj5 = {
                    backgroundColor: c.bold.warning.background,
                    color: c.bold.warning.text
                }, _define_property(_obj5, ".".concat(alertClasses.icon), {
                    color: c.bold.warning.icon
                }), _define_property(_obj5, ".".concat(alertClasses.action), {
                    color: c.bold.warning.action
                }), _obj5)), _obj6)), _obj7)
            },
            variants: [
                {
                    props: {
                        squared: true
                    },
                    style: {
                        borderRadius: rem(0)
                    }
                },
                {
                    props: {
                        condensed: true
                    },
                    style: _define_property({
                        padding: "".concat(rem(spacing[0]), " ").concat(rem(spacing[2])),
                        minHeight: rem(36)
                    }, ".".concat(alertClasses.icon), {
                        fontSize: rem(16)
                    })
                },
                {
                    props: {
                        color: 'support'
                    },
                    style: (_obj9 = {}, _define_property(_obj9, "&.".concat(alertClasses.standard), _define_property({
                        backgroundColor: c.special.background,
                        color: c.special.text
                    }, ".".concat(alertClasses.icon), {
                        color: c.special.icon
                    })), _define_property(_obj9, "&.".concat(alertClasses.outlined), _define_property({
                        backgroundColor: c.special.background,
                        color: c.special.text,
                        borderColor: c.special.border
                    }, ".".concat(alertClasses.icon), {
                        color: c.special.icon
                    })), _define_property(_obj9, "&.".concat(alertClasses.filled), (_obj8 = {
                        backgroundColor: c.bold.special.background,
                        color: c.bold.special.text
                    }, _define_property(_obj8, ".".concat(alertClasses.icon), {
                        color: c.bold.special.icon
                    }), _define_property(_obj8, ".".concat(alertClasses.action), {
                        color: c.bold.special.action
                    }), _obj8)), _obj9)
                },
                {
                    props: {
                        color: 'default'
                    },
                    style: (_obj11 = {}, _define_property(_obj11, "&.".concat(alertClasses.standard), _define_property({
                        backgroundColor: c.default.background,
                        color: c.default.text
                    }, ".".concat(alertClasses.icon), {
                        color: c.default.icon
                    })), _define_property(_obj11, "&.".concat(alertClasses.outlined), _define_property({
                        backgroundColor: c.default.background,
                        color: c.default.text,
                        borderColor: c.default.border
                    }, ".".concat(alertClasses.icon), {
                        color: c.default.icon
                    })), _define_property(_obj11, "&.".concat(alertClasses.filled), (_obj10 = {
                        backgroundColor: c.bold.default.background,
                        color: c.bold.default.text
                    }, _define_property(_obj10, ".".concat(alertClasses.icon), {
                        color: c.bold.default.icon
                    }), _define_property(_obj10, ".".concat(alertClasses.action), {
                        color: c.bold.default.action
                    }), _obj10)), _obj11)
                }
            ],
            defaultProps: {
                variant: 'standard',
                severity: 'info'
            }
        }
    };
    return override;
};

//# sourceMappingURL=Alert.js.map